import $ from 'jquery';
import "./quickBtnExpander.less";

// NOTE: write out utility below another day



// WEBPACK FOOTER //
// ./src/utilities/quickBtnExpander/index.js